//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: 'person-list',
    data: function data() {
        return {
            loading: true,
            headers: ["Name", "Property", { title: 'Date Created', filter: 'dateFull' }, "City", "Email", "Phone"],
            fields: ["full_name", "property.name", "created_at", "city", "email", "phone"],
            persons: [],
            totalRecord: 0
        };
    },
    created: function created() {
        var $el = this;

        Event.$on('remove-guest-card', this.removeGuestCard);

        Event.$on('person-updated', function () {
            $el.refresh();
        });

        Event.$on("delete-entry", function (item) {
            $el.refresh();
        });
    },
    beforeDestroy: function beforeDestroy() {
        Event.$off('remove-resident');
        Event.$off('person-updated');
        Event.$off('delete-entry');
    },
    mounted: function mounted() {
        var $el = this;
        this.refresh();
        $el.loading = true;
    },

    methods: {
        addNew: function addNew() {
            Event.$emit('new-request');
        },
        removeGuestCard: function removeGuestCard(item) {
            Event.$emit("confirm-delete", item, "/prototype/person/" + item.id, "delete-entry", "Are you sure you want to archive this person?", "Delete", "", true);
        },
        refresh: function refresh() {
            var $el = this;
            axios.get("/prototype/guest-cards").then(function (response) {
                $el.persons = response.data;
                $el.totalRecord = response.data.length;
                $el.loading = false;
            });
        }
    }

};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/person/guest-cards/GuestCardList.vue
// module id = +FSS
// module chunks = 0 1